// extracted by mini-css-extract-plugin
export default {"alertContainer":"AlertContainer_alertContainer__XRi12"};